/* SLEEP by mööds, Shopify theme (t122). The behaviour below is the approved static page's script, kept as close to
   verbatim as the theme allows: element lookups go through classes/data attributes instead of single page ids so a
   section can be re-rendered in the theme editor, and the demo cart is replaced with the real AJAX cart. */
(function(){
  'use strict';
  const T=window.theme||{};
  const $=id=>document.getElementById(id);
  const reduceQ=matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- money ---------- */
  function formatMoney(cents,format){
    if(typeof cents==='string')cents=cents.replace('.','');
    format=format||T.moneyFormat||'${{amount}}';
    const re=/\{\{\s*(\w+)\s*\}\}/;
    const fmt=(n,p,t=',',d='.')=>{if(isNaN(n)||n==null)return '0';n=(n/100).toFixed(p);const parts=n.split('.');return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,'$1'+t)+(parts[1]?d+parts[1]:'')};
    const m=format.match(re); if(!m) return format;
    let v;
    switch(m[1]){
      case 'amount':v=fmt(cents,2);break;
      case 'amount_no_decimals':v=fmt(cents,0);break;
      case 'amount_with_comma_separator':v=fmt(cents,2,'.',',');break;
      case 'amount_no_decimals_with_comma_separator':v=fmt(cents,0,'.',',');break;
      case 'amount_with_apostrophe_separator':v=fmt(cents,2,"'",'.');break;
      case 'amount_no_decimals_with_space_separator':v=fmt(cents,0,' ');break;
      case 'amount_with_space_separator':v=fmt(cents,2,' ',',');break;
      case 'amount_with_period_and_space_separator':v=fmt(cents,2,' ','.');break;
      default:v=fmt(cents,2);
    }
    return format.replace(re,v);
  }
  const esc=s=>String(s==null?'':s).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));

  /* ---------- header: clear over the hero, frosted white once you scroll (home only; other pages start frosted) ---------- */
  (()=>{const nav=document.querySelector('.nav[data-frost]');if(!nav)return;const set=()=>nav.classList.toggle('scrolled',scrollY>24);set();addEventListener('scroll',set,{passive:true});})();

  /* ---------- FAQ deep links (#faq-subscriptions, #faq-cancel): open the matching answer ---------- */
  (()=>{const go=()=>{const id=decodeURIComponent(location.hash.slice(1));const d=id&&document.getElementById(id);if(d&&d.tagName==='DETAILS'){d.open=true;d.scrollIntoView({block:'center'});d.querySelector('summary').focus({preventScroll:true})}};addEventListener('hashchange',go);go();
    // same-page links to an answer that is already the current hash still open it
    document.addEventListener('click',e=>{const a=e.target.closest('a[href*="#faq-"]');if(!a)return;const u=new URL(a.href,location.href);if(u.pathname===location.pathname&&u.hash===location.hash){e.preventDefault();go()}});
  })();

  /* ---------- sunset in the bedtime section: --s runs 0..1 while the section crosses the viewport ---------- */
  let sunsets=[];
  function initSunset(root){
    root.querySelectorAll('.planner-sec').forEach(sunset=>{
      if(sunset.dataset.ready)return; sunset.dataset.ready='1';
      const firstStep=sunset.querySelector('.steps li')||sunset;
      if(reduceQ.matches){ sunset.style.setProperty('--s','0.6'); return; }
      sunsets.push({sunset,firstStep});
    });
    sunsetTick();
  }
  function sunsetTick(){
    sunsets=sunsets.filter(x=>x.sunset.isConnected);
    for(const {sunset,firstStep} of sunsets){
      // starts once step 1 ("Two sprays under the tongue") is on screen, finishes as the section scrolls up out of view
      const r=sunset.getBoundingClientRect(), s1=firstStep.getBoundingClientRect();
      const start=s1.top-innerHeight*0.95, end=r.bottom-innerHeight*0.55;
      const p=Math.min(1,Math.max(0,-start/Math.max(1,end-start)));
      sunset.style.setProperty('--s',(p*p*(3-2*p)).toFixed(3));
    }
  }
  let sunTicking=false;
  addEventListener('scroll',()=>{ if(!sunTicking&&sunsets.length){sunTicking=true;requestAnimationFrame(()=>{sunTicking=false;sunsetTick()});} },{passive:true});
  addEventListener('resize',sunsetTick);

  /* ---------- bedtime planner: 9:00 PM to 2:00 AM in 15-minute steps ---------- */
  const fmt=m=>{m=((m%1440)+1440)%1440;let h=Math.floor(m/60),mm=m%60;const ap=h>=12?'PM':'AM';h=h%12||12;return `${h}:${String(mm).padStart(2,'0')}<small style="font-size:.45em;margin-left:3px">${ap}</small>`};
  function initPlanner(root){
    root.querySelectorAll('.clock').forEach(clock=>{
      const bed=clock.querySelector('input.bed'); if(!bed||bed.dataset.ready)return; bed.dataset.ready='1';
      const q=c=>clock.querySelector(c);
      function plan(){const sleep=21*60+bed.valueAsNumber*15;q('.t-sleep').innerHTML=fmt(sleep);q('.t-dim').innerHTML=fmt(sleep-15);q('.t-spray').innerHTML=fmt(sleep-30);bed.setAttribute('aria-valuetext','Asleep at '+q('.t-sleep').textContent)}
      const fill=()=>bed.style.setProperty('--f',(bed.valueAsNumber-bed.min)/(bed.max-bed.min)*100+'%');
      bed.addEventListener('input',()=>{plan();fill();});
      plan();fill();
    });
  }

  /* ---------- ritual clips: play while on screen, never under reduced motion ---------- */
  const clipIO=(!reduceQ.matches&&'IntersectionObserver' in window)?new IntersectionObserver(es=>es.forEach(e=>{e.isIntersecting?e.target.play().catch(()=>{}):e.target.pause()}),{threshold:.35}):null;
  function initClips(root){ if(clipIO) root.querySelectorAll('.ritual video').forEach(v=>clipIO.observe(v)); }

  /* ---------- hero aurora leans toward the pointer: eased, fine pointers only, off under reduced motion ---------- */
  function initAurora(root){
    const hero=root.querySelector('#hero'); if(!hero||hero.dataset.ready)return; hero.dataset.ready='1';
    if(!matchMedia('(pointer:fine)').matches||reduceQ.matches)return;
    let tx=0,ty=0,x=0,y=0,raf=0;
    const step=()=>{x+=(tx-x)*.06;y+=(ty-y)*.06;hero.style.setProperty('--mx',x.toFixed(4));hero.style.setProperty('--my',y.toFixed(4));raf=(Math.abs(tx-x)>.001||Math.abs(ty-y)>.001)?requestAnimationFrame(step):0;};
    hero.addEventListener('pointermove',e=>{const r=hero.getBoundingClientRect();tx=(e.clientX-r.left)/r.width-.5;ty=(e.clientY-r.top)/r.height-.5;if(!raf)raf=requestAnimationFrame(step);});
    hero.addEventListener('pointerleave',()=>{tx=0;ty=0;if(!raf)raf=requestAnimationFrame(step);});
  }

  /* ---------- product tilt: follows the pointer on the hero render and the main gallery render.
     Spring-eased, transform/opacity only, fine pointers only, off under reduced motion. (max:0 = a gentle lift, no tilt) ---------- */
  const fine=matchMedia('(pointer:fine)');
  function tilt(zone,target,shadow,{max=8,lift=10,fade=false,active=()=>true}={}){
    if(!zone||!target) return;
    const s={x:0,y:0,l:0,vx:0,vy:0,vl:0}, goal={x:0,y:0,l:0};
    const K=150,D=17; let raf=0,last=0;
    function paint(){
      if(Math.abs(s.x)<.005&&Math.abs(s.y)<.005&&s.l<.005&&!goal.l){target.style.transform='';if(shadow){shadow.style.translate='';if(fade)shadow.style.opacity=''}return}
      target.style.transform=`perspective(1100px) translate3d(0,${(-s.l*lift).toFixed(2)}px,0) rotateX(${s.y.toFixed(3)}deg) rotateY(${s.x.toFixed(3)}deg)`;
      if(shadow){shadow.style.translate=`${(-s.x*2.2).toFixed(2)}px ${(s.y*1.2+s.l*4).toFixed(2)}px`;if(fade){shadow.style.opacity=(s.l*.85).toFixed(3);shadow.style.transform=`scale(${(1-s.l*.12+Math.abs(s.x)*.01).toFixed(3)})`}}
    }
    function frame(t){
      const dt=last?Math.min(.034,(t-last)/1000):1/60; last=t;
      let busy=false;
      for(const k of ['x','y','l']){const v='v'+k;s[v]+=(K*(goal[k]-s[k])-D*s[v])*dt;s[k]+=s[v]*dt;if(Math.abs(goal[k]-s[k])>.002||Math.abs(s[v])>.002)busy=true}
      paint();
      if(busy) raf=requestAnimationFrame(frame); else {raf=0;last=0;Object.assign(s,{x:goal.x,y:goal.y,l:goal.l,vx:0,vy:0,vl:0});paint()}
    }
    const kick=()=>{if(!raf)raf=requestAnimationFrame(frame)};
    zone.addEventListener('pointermove',e=>{
      if(e.pointerType==='touch'||!fine.matches||reduceQ.matches||!active()) return;
      const r=zone.getBoundingClientRect();
      const px=Math.max(-1,Math.min(1,((e.clientX-r.left)/r.width-.5)*2)), py=Math.max(-1,Math.min(1,((e.clientY-r.top)/r.height-.5)*2));
      goal.x=px*max; goal.y=-py*max; goal.l=1; kick();
    });
    zone.addEventListener('pointerleave',()=>{goal.x=0;goal.y=0;goal.l=0;kick()});
    return ()=>{goal.x=goal.y=goal.l=0;Object.assign(s,{x:0,y:0,l:0,vx:0,vy:0,vl:0});paint()};
  }
  function initTilt(root){
    const art=root.querySelector('.art');
    if(art&&!art.dataset.ready){art.dataset.ready='1';tilt(art,art.querySelector('.push.tilt'),art.querySelector('.float-shadow'),{max:0,lift:6});}
    root.querySelectorAll('.gallery').forEach(g=>{
      if(g.dataset.ready)return; g.dataset.ready='1';
      const main=g.querySelector('.main'), gm=g.querySelector('[data-g-main]');
      const reset=tilt(main,gm,main&&main.querySelector('.tilt-shadow'),{max:0,lift:8,fade:true,active:()=>!main.classList.contains('photo')});
      // gallery
      g.querySelectorAll('.thumbs button').forEach(b=>b.addEventListener('click',()=>{
        g.querySelectorAll('.thumbs button').forEach(x=>x.setAttribute('aria-pressed',x===b));
        gm.removeAttribute('srcset');gm.src=b.dataset.local;if(b.dataset.srcset){gm.sizes='(max-width:900px) 100vw, 600px';gm.srcset=b.dataset.srcset}gm.style.objectPosition=b.dataset.pos||'';gm.alt=b.dataset.alt;main.classList.toggle('photo','photo' in b.dataset);
        reset&&reset();
      }));
    });
  }

  /* ---------- endocannabinoid section: receptor points light in sequence as the section scrolls (CB1 first, then CB2) ---------- */
  function initEcs(root){
    root.querySelectorAll('.ecs').forEach(sec=>{
      if(sec.dataset.ready||reduceQ.matches) return; sec.dataset.ready='1';
      sec.classList.add('armed');
      const track=sec.querySelector('.ecs-track'), stage=sec.querySelector('.ecs-stage');
      const groups=[['cb1',.04,.44],['cb2',.52,.9]].map(([g,a,b])=>({pts:[...sec.querySelectorAll('.rp.'+g)],li:sec.querySelector('.ecs-legend [data-group='+g+']'),a,b}));
      let ticking=false;
      function update(){
        ticking=false;
        if(!sec.isConnected) return;
        // same mapping on every width: progress through the pinned stage
        const r=track.getBoundingClientRect();
        const p=Math.max(0,Math.min(1,-r.top/Math.max(1,r.height-stage.offsetHeight)));
        // phone copy: items come up in order and stay (step 4 = the blend line); desktop shows all copy at once
        sec.dataset.step=p<.12?1:p<.5?2:p<.9?3:4;
        for(const g of groups){
          const n=g.pts.length;
          g.pts.forEach((el,k)=>el.classList.toggle('on',p>=g.a+(g.b-g.a)*(n>1?k/(n-1):0)));
          if(g.li) g.li.classList.toggle('on',p>=g.a);
        }
      }
      // phones: size the figure in px so the pinned stage's content fits its min-height exactly
      const fig=sec.querySelector('.ecs-fig'), phone=matchMedia('(max-width:860px)');
      function fit(){
        if(!phone.matches){fig.style.removeProperty('--fig-h');return}
        const cs=getComputedStyle(stage), target=parseFloat(cs.minHeight)-parseFloat(cs.paddingTop)-parseFloat(cs.paddingBottom);
        const grid=sec.querySelector('.ecs-grid'), other=grid.offsetHeight-fig.offsetHeight;
        const h=Math.max(140,Math.min(target*.6,target-other));
        fig.style.setProperty('--fig-h',Math.floor(h)+'px');
      }
      addEventListener('scroll',()=>{if(!ticking){ticking=true;requestAnimationFrame(update)}},{passive:true});
      addEventListener('resize',()=>{fit();update()});
      fit(); update();
      if(document.fonts&&document.fonts.ready) document.fonts.ready.then(fit);
    });
  }

  /* ---------- cart: AJAX drawer ---------- */
  const drawer=$('drawer'), body=$('cart-body'), status=$('cart-status');
  let cartOpener=null;
  const S=T.strings||{};
  const routes=T.routes||{cart:'/cart',cartAdd:'/cart/add',cartChange:'/cart/change'};
  function setCount(n){document.querySelectorAll('#cart-count').forEach(el=>el.textContent=n)}
  function img(url,w){if(!url)return '';return url+(url.includes('?')?'&':'?')+'width='+w}
  function renderCart(cart){
    if(!drawer) return;
    setCount(cart.item_count);
    $('cart-subtotal').innerHTML=formatMoney(cart.total_price);
    const btn=drawer.querySelector('#cart-checkout button'); if(btn) btn.disabled=!cart.item_count;
    if(!cart.item_count){ body.innerHTML=`<p class="cart-empty">${esc(S.empty||'Your cart is empty.')}</p>`; return; }
    body.innerHTML=cart.items.map((it,i)=>{
      const line=i+1;
      const variant=(it.variant_title&&!/^Default Title$/i.test(it.variant_title))?`<div class="li-meta">${esc(it.variant_title)}</div>`:'';
      const plan=it.selling_plan_allocation&&it.selling_plan_allocation.selling_plan?`<span class="li-plan">${esc(it.selling_plan_allocation.selling_plan.name)}</span>`:'';
      const props=it.properties?Object.entries(it.properties).filter(([k,v])=>v&&k.charAt(0)!=='_').map(([k,v])=>`<div class="li-meta">${esc(k)}: ${esc(v)}</div>`).join(''):'';
      const was=it.original_line_price>it.final_line_price?`<s>${formatMoney(it.original_line_price)}</s>`:'';
      return `<div class="line-item" data-line="${line}">
        ${it.image?`<img src="${esc(img(it.image,200))}" alt="" width="72" height="72" loading="lazy">`:'<span></span>'}
        <div><a class="li-title" href="${esc(it.url)}">${esc(it.product_title)}</a>${variant}${plan}${props}
          <div class="li-ctrl"><span class="li-qty"><button type="button" data-step="-1" aria-label="${esc(S.decrease||'Decrease quantity')}: ${esc(it.product_title)}">−</button><span aria-label="${esc(S.qty||'Quantity')}">${it.quantity}</span><button type="button" data-step="1" aria-label="${esc(S.increase||'Increase quantity')}: ${esc(it.product_title)}">+</button></span><button type="button" class="li-remove" data-remove aria-label="${esc(S.remove||'Remove')}: ${esc(it.product_title)}">${esc(S.remove||'Remove')}</button></div>
        </div>
        <b class="li-price">${formatMoney(it.final_line_price)}${was}</b>
      </div>`;
    }).join('');
  }
  async function getCart(){const r=await fetch(routes.cart+'.js',{headers:{Accept:'application/json'}});return r.json()}
  async function change(line,quantity){
    drawer.classList.add('busy');
    try{
      const r=await fetch(routes.cartChange+'.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({line,quantity})});
      const cart=await r.json();
      if(!r.ok) throw new Error(cart.description||cart.message||'');
      renderCart(cart); say(S.updated||'Cart updated.');
    }catch(err){ say((err&&err.message)||S.error||'Something went wrong. Please try again.'); renderCart(await getCart()); }
    finally{drawer.classList.remove('busy')}
  }
  function say(t){ if(status){status.textContent='';setTimeout(()=>status.textContent=t,30)} }
  function openDrawer(from){
    if(!drawer) return false;
    cartOpener=from||document.activeElement; drawer.hidden=false; $('cart-close').focus();
    return true;
  }
  function closeDrawer(){ if(!drawer||drawer.hidden) return; drawer.hidden=true; const o=cartOpener&&cartOpener.isConnected?cartOpener:$('cart-open'); o&&o.focus(); }
  if(drawer){
    const opener=$('cart-open');
    if(opener) opener.addEventListener('click',async e=>{e.preventDefault();openDrawer(opener);try{renderCart(await getCart())}catch(_){}});
    $('cart-close').addEventListener('click',closeDrawer);
    document.addEventListener('keydown',e=>{if(e.key==='Escape'&&!drawer.hidden)closeDrawer()});
    body.addEventListener('click',e=>{
      const li=e.target.closest('.line-item'); if(!li) return;
      const line=Number(li.dataset.line), cur=Number(li.querySelector('.li-qty span').textContent);
      const st=e.target.closest('[data-step]'); if(st){ change(line,Math.max(0,cur+Number(st.dataset.step))); return; }
      if(e.target.closest('[data-remove]')) change(line,0);
    });
    // the server-rendered count can be stale after back/forward cache restores
    addEventListener('pageshow',e=>{if(e.persisted)getCart().then(renderCart).catch(()=>{})});
  }

  /* ---------- buy box: purchase options, quantity, add to cart ---------- */
  function initBuy(root){
    root.querySelectorAll('[data-product-form]').forEach(form=>{
      if(form.dataset.ready) return; form.dataset.ready='1';
      const box=form.closest('[data-buy-box]')||form.parentNode;
      const add=form.querySelector('[data-add]'), msg=form.querySelector('[data-buy-msg]');
      const qIn=form.querySelector('[data-qty-input]'), qOut=form.querySelector('[data-qty-out]');
      let variants=[]; try{variants=JSON.parse(form.querySelector('[data-variants]').textContent)}catch(_){}
      let q=1;
      form.querySelectorAll('[data-qty]').forEach(b=>b.addEventListener('click',()=>{q=Math.min(9,Math.max(1,q+Number(b.dataset.qty)));qOut.textContent=q;qIn.value=q}));
      const idEl=form.querySelector('[data-variant-id]');
      function syncVariant(){
        const v=variants.find(x=>String(x.id)===String(idEl.value)); if(!v) return;
        const once=form.querySelector('[data-price="once"]'); if(once) once.innerHTML=v.price;
        form.querySelectorAll('input[name=selling_plan][data-plan]').forEach(r=>{
          if(r.dataset.plan==='once') return;
          const a=v.plans[r.dataset.plan], cell=form.querySelector(`[data-price="${r.dataset.plan}"]`), save=r.closest('.opt').querySelector('b');
          r.disabled=!a; if(cell) cell.innerHTML=a?a.price:'';
          if(save){const old=save.querySelector('.save');if(old)old.remove();if(a&&a.save){save.insertAdjacentHTML('beforeend',a.save)}}
        });
        add.disabled=!v.available; add.textContent=v.available?add.dataset.label:(add.dataset.soldout||add.textContent);
        const u=new URL(location.href); if(u.searchParams.has('variant')||idEl.tagName==='SELECT'){u.searchParams.set('variant',v.id);history.replaceState(null,'',u)}
      }
      if(idEl&&idEl.tagName==='SELECT') idEl.addEventListener('change',syncVariant);
      form.addEventListener('submit',async e=>{
        if(!drawer) return; // no drawer: let the form post to /cart/add
        e.preventDefault();
        msg.hidden=true; add.disabled=true;
        const fd=new FormData(form);
        if(!fd.get('selling_plan')) fd.delete('selling_plan');
        try{
          const r=await fetch(routes.cartAdd+'.js',{method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:fd});
          const res=await r.json();
          if(!r.ok) throw new Error(res.description||res.message||S.error);
          q=1;qOut.textContent=1;qIn.value=1;
          openDrawer(add); say(S.added||'Added to cart.');
          renderCart(await getCart());
        }catch(err){
          msg.textContent=(err&&err.message)||S.error||'Something went wrong. Please try again.'; msg.hidden=false;
        }finally{ const v=variants.find(x=>String(x.id)===String(idEl&&idEl.value)); add.disabled=v?!v.available:false; }
      });
    });
  }

  /* ---------- newsletter: Shopify customer form, sent in the background ---------- */
  async function postCustomer(form,extra){
    const fd=new FormData(form); if(extra) for(const [k,v] of Object.entries(extra)) fd.set(k,v);
    const r=await fetch(form.action,{method:'POST',body:fd,headers:{Accept:'text/html'}});
    if(r.url&&/\/challenge/.test(r.url)) return 'challenge';
    if(!r.ok) throw new Error('Shopify responded '+r.status);
    return 'ok';
  }
  function initJoin(root){
    root.querySelectorAll('form[data-join]').forEach(f=>{
      if(f.dataset.ready) return; f.dataset.ready='1';
      const input=f.querySelector('input[type=email]'), m=f.querySelector('[data-join-msg]'), btn=f.querySelector('[type=submit]');
      f.addEventListener('submit',async e=>{
        e.preventDefault();
        const v=input.value.trim();
        if(!/^\S+@\S+\.\S+$/.test(v)){m.textContent=m.dataset.invalid;input.setAttribute('aria-invalid','true');input.focus();return}
        input.removeAttribute('aria-invalid'); btn.disabled=true;
        try{
          const r=await postCustomer(f);
          if(r==='challenge'){ f.submit(); return; }
          m.textContent=m.dataset.ok; input.value='';
        }catch(err){ console.warn('[newsletter]',err); m.textContent=m.dataset.fail; }
        finally{ btn.disabled=false; }
      });
    });
  }

  /* ---------- sleep quiz: six questions, a profile, a routine, and an optional email capture ---------- */
  function initQuiz(root){
  const dlg=root.querySelector('#quiz'), main=dlg&&dlg.querySelector('#quiz-main');
  if(!dlg||dlg.dataset.ready||typeof dlg.showModal!=='function') return;
  dlg.dataset.ready='1';
  const cfg=dlg.dataset;
  const reduce=()=>reduceQ.matches;
  const prog=dlg.querySelector('.q-prog');
  const Q=[
    {id:'obstacle',q:'What gets in the way of your sleep most?',o:[['falling','Trouble falling asleep'],['waking','Waking up in the night'],['racing','A racing mind'],['schedule','An irregular schedule']]},
    {id:'bedtime',q:'When do you usually go to bed?',o:[['21','Around 9 pm'],['22','Around 10 pm'],['23','Around 11 pm'],['24','Midnight or later']]},
    {id:'caffeine',q:'Do you have caffeine after 2 pm?',o:[['yes','Yes'],['no','No'],['sometimes','Sometimes']]},
    {id:'screens',q:'Do you use screens in bed?',o:[['yes','Yes'],['no','No'],['sometimes','Sometimes']]},
    {id:'melatonin',q:'Have you tried melatonin?',o:[['never','Never tried it'],['worked','Yes, and it worked'],['groggy','Yes, but it left me groggy'],['stopped','Yes, but it stopped working']]},
    {id:'goal',q:'What do you want most from your nights?',o:[['faster','Fall asleep faster'],['stay','Stay asleep'],['clear','Wake up clear-headed'],['calm','A calmer wind-down']]}
  ];
  const P={
    racing:{name:'The Racing Mind',desc:'Your body is ready for bed before your mind is. The day keeps replaying, so lying down turns into thinking time instead of sleep time.',tips:['Write tomorrow’s to-do list before you get into bed, so it lives on paper and not in your head.','Try slow breathing once the lights are out: in for four, out for six, for a few minutes.','If you’re still awake after twenty minutes, get up, keep the lights low, and go back when you feel sleepy.']},
    waker:{name:'The 3 a.m. Waker',desc:'Falling asleep isn’t the hard part. Staying there is: you wake in the small hours and the night starts to feel long.',tips:['Keep the bedroom cool, dark and quiet. Small disturbances are easier to sleep through in a cooler room.','If you wake, don’t check the time. Clock-watching tends to wake you up more.','Ease off alcohol in the evening. It can make the second half of the night lighter.']},
    owl:{name:'The Night Owl',desc:'Your body clock runs late, or your schedule won’t let it settle. Bedtime keeps moving, so your body never quite knows when night starts.',tips:['Wake up at the same time every day, weekends included. A steady wake time anchors everything else.','Get daylight early. Ten minutes outside in the morning helps set your clock.','Move bedtime earlier in 15-minute steps rather than all at once.']},
    settler:{name:'The Slow Settler',desc:'You’re tired, but sleep takes its time arriving. You lie there waiting for it, and the waiting becomes part of the problem.',tips:['Start winding down an hour before bed: lights low, nothing urgent, nothing new.','Take a warm shower before bed. Cooling down afterward is part of how your body gets ready for sleep.','Keep the bed for sleep, so getting into it starts to mean sleep.']}
  };
  const CAFFEINE={yes:'Make 2 pm your caffeine cutoff. Caffeine can stay in your system for hours after the last cup.',sometimes:'On afternoons you’d reach for caffeine, switch to decaf or a herbal tea instead.'};
  const SCREENS={yes:'Charge your phone outside the bedroom, or at least out of reach, and swap the scroll for a book.',sometimes:'Make the last thirty minutes before bed screen-free, even on nights you’d usually scroll.'};
  const GOALS={faster:'Fall asleep faster',stay:'Stay asleep',clear:'Wake up clear-headed',calm:'A calmer wind-down'};

  let a={}, step=0, opener=null;
  const clock=m=>{m=((m%1440)+1440)%1440;let h=Math.floor(m/60);const mm=String(m%60).padStart(2,'0'),ap=h>=12?'pm':'am';h=h%12||12;return {t:`${h}:${mm}`,ap}};
  const say=m=>{const c=clock(m);return `${c.t} ${c.ap}`};
  const cell=m=>{const c=clock(m);return `${c.t}<small style="font-size:.45em;margin-left:3px">${c.ap.toUpperCase()}</small>`};

  function profile(){
    const s={racing:0,waker:0,owl:0,settler:0};
    const lead={falling:'settler',waking:'waker',racing:'racing',schedule:'owl'}[a.obstacle]||'settler';
    s[lead]+=3;
    ({faster:()=>s.settler+=2,stay:()=>s.waker+=2,clear:()=>{s.owl+=1;s.waker+=1},calm:()=>s.racing+=2}[a.goal]||(()=>{}))();
    if(a.bedtime==='24')s.owl+=2; else if(a.bedtime==='23')s.owl+=1;
    if(a.screens==='yes')s.racing+=1; else if(a.screens==='sometimes')s.racing+=.5;
    if(a.caffeine==='yes'){s.settler+=1;s.owl+=.5}
    if(a.melatonin==='groggy'||a.melatonin==='stopped')s.waker+=.5;
    return Object.keys(s).sort((x,y)=>s[y]-s[x]||(y===lead)-(x===lead))[0];
  }

  function setProgress(n){prog.style.setProperty('--p',n/Q.length);prog.setAttribute('aria-valuenow',n);prog.setAttribute('aria-valuetext',n>=Q.length?'Complete':`Question ${n+1} of ${Q.length}`)}
  function enter(){dlg.scrollTop=0;const h=main.querySelector('.q-h');h&&h.focus({preventScroll:true})}

  function show(i){
    step=i;
    if(i>=Q.length) return result();
    const q=Q[i];
    setProgress(i);
    main.innerHTML=`<div class="q-screen q-in">
      <p class="q-count">Question ${i+1} of ${Q.length}</p>
      <h2 class="q-h" id="q-h" tabindex="-1">${q.q}</h2>
      <div class="q-opts${q.o.length===3?' three':''}" role="group" aria-labelledby="q-h">${q.o.map(([v,l])=>`<button type="button" class="q-opt" data-v="${v}" aria-pressed="${a[q.id]===v}">${l}</button>`).join('')}</div>
      ${i>0?'<div class="q-nav"><button type="button" class="btn btn-soft q-back">Back</button></div>':''}
    </div>`;
    main.querySelectorAll('.q-opt').forEach(b=>b.addEventListener('click',()=>{
      a[q.id]=b.dataset.v;
      main.querySelectorAll('.q-opt').forEach(x=>x.setAttribute('aria-pressed',x===b));
      setTimeout(()=>show(i+1),reduce()?0:240);
    }));
    const back=main.querySelector('.q-back'); if(back) back.addEventListener('click',()=>show(i-1));
    enter();
  }

  function result(){
    setProgress(Q.length);
    const key=profile(), p=P[key];
    const bed=Number(a.bedtime||22)*60, spray=bed-30;
    const tips=[];
    if(CAFFEINE[a.caffeine])tips.push(CAFFEINE[a.caffeine]);
    if(SCREENS[a.screens])tips.push(SCREENS[a.screens]);
    for(const t of p.tips){if(tips.length>=3)break;tips.push(t)}
    const mel={groggy:' SLEEP is melatonin-free, so there’s no melatonin in it to leave you groggy.',stopped:' SLEEP is melatonin-free: a different approach, not more of the same.'}[a.melatonin]||'';
    const data={sleep_profile:p.name,bedtime:say(bed),spray_time:say(spray),goal:GOALS[a.goal]||''};
    main.innerHTML=`<div class="q-screen q-in">
      <p class="q-count">Your result</p>
      <h2 class="q-h" id="q-h" tabindex="-1">${p.name}</h2>
      <p class="q-desc">${p.desc}</p>
      <div class="q-block">
        <h3>Your routine</h3>
        <div class="times">
          <div class="t hi"><span>Spray</span><b>${cell(spray)}</b></div>
          <div class="t"><span>Lights low</span><b>${cell(bed-10)}</b></div>
          <div class="t"><span>In bed</span><b>${cell(bed)}</b></div>
        </div>
        <p class="q-note">Spray at ${say(spray)}: two sprays under the tongue, hold for 30 seconds, then swallow.${mel}</p>
      </div>
      <div class="q-block">
        <h3>Three things to try</h3>
        <ol class="q-tips">${tips.map(t=>`<li><span>${t}</span></li>`).join('')}</ol>
      </div>
      <div class="q-ctas"><a class="btn btn-primary" href="${esc(cfg.shopLink||'#shop')}" data-shop>${esc(cfg.shopLabel||'Try SLEEP')}</a><button type="button" class="btn btn-soft" data-retake>Retake the quiz</button></div>
      <div class="q-mail">
        <h3 id="q-mail-h">${esc(cfg.mailHeading)}</h3>
        <form id="q-form" novalidate aria-labelledby="q-mail-h">
          <label class="lbl" for="q-email">Email address</label>
          <input id="q-email" type="email" name="email" autocomplete="email" inputmode="email" placeholder="you@example.com" required>
          <label class="q-consent"><input type="checkbox" id="q-consent" required><span>${esc(cfg.consent)}</span></label>
          <button class="btn btn-primary" type="submit">${esc(cfg.send)}</button>
        </form>
        <p class="q-msg" id="q-msg" role="status" aria-live="polite"></p>
      </div>
      <p class="q-fine">${esc(cfg.fine)}</p>
    </div>`;
    main.querySelector('[data-shop]').addEventListener('click',e=>{
      const href=e.currentTarget.getAttribute('href');
      const target=href.charAt(0)==='#'&&document.querySelector(href);
      if(!target) return; // another page: follow the link
      e.preventDefault();dlg.close();target.scrollIntoView({behavior:reduce()?'auto':'smooth'})});
    main.querySelector('[data-retake]').addEventListener('click',()=>{a={};show(0)});
    wireForm(data,key);
    enter();
  }

  function wireForm(props,key){
    const form=main.querySelector('#q-form'), email=form.querySelector('#q-email'), consent=form.querySelector('#q-consent'), msg=main.querySelector('#q-msg'), btn=form.querySelector('[type=submit]');
    const fail=(text,el)=>{msg.className='q-msg err';msg.textContent=text;if(el){el.setAttribute('aria-invalid','true');el.focus()}};
    const K=T.klaviyo||{};
    form.addEventListener('submit',async e=>{
      e.preventDefault();
      email.removeAttribute('aria-invalid');consent.removeAttribute('aria-invalid');
      const v=email.value.trim();
      if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) return fail('Enter a valid email address, like you@example.com.',email);
      if(!consent.checked) return fail('Tick the box to say it’s OK to email you.',consent);
      msg.className='q-msg';msg.textContent='Sending…';btn.disabled=true;
      try{
        // 1. Shopify: the email becomes a customer subscribed to marketing, tagged (default "sleep-quiz")
        const shopForm=document.querySelector('form[data-quiz-form]');
        let shopify='skipped', klaviyo='skipped';
        const jobs=[];
        if(shopForm) jobs.push(postCustomer(shopForm,{'contact[email]':v}).then(r=>shopify=r,err=>{console.warn('[sleep quiz] Shopify',err);shopify='error'}));
        // 2. Klaviyo, when Theme settings > Sleep quiz has both the public key and the list id
        if(K.publicKey&&K.listId){
          jobs.push(fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+encodeURIComponent(K.publicKey),{
            method:'POST',
            headers:{'content-type':'application/vnd.api+json',accept:'application/vnd.api+json',revision:K.revision||'2024-10-15'},
            body:JSON.stringify({data:{type:'subscription',attributes:{custom_source:'Sleep quiz',profile:{data:{type:'profile',attributes:{email:v,properties:props}}}},relationships:{list:{data:{type:'list',id:K.listId}}}}})
          }).then(res=>{klaviyo=res.ok?'ok':'error';if(!res.ok)console.warn('[sleep quiz] Klaviyo responded '+res.status)},err=>{console.warn('[sleep quiz] Klaviyo',err);klaviyo='error'}));
        }
        await Promise.all(jobs);
        if(shopify!=='ok'&&klaviyo!=='ok'){
          // Shopify asked for a bot check and nothing else caught the email: finish the signup on Shopify's own page
          if(shopify==='challenge'){ shopForm.querySelector('[name="contact[email]"]').value=v; shopForm.submit(); return; }
          throw new Error('No signup went through');
        }
        form.hidden=true;msg.className='q-msg ok';msg.textContent=cfg.ok;
        if(T.quizCode){const c=document.createElement('span');c.style.display='block';c.style.marginTop='8px';c.textContent=(cfg.codeLabel||'Your code: [code]').replace('[code]',T.quizCode);msg.appendChild(c)}
        msg.setAttribute('tabindex','-1');msg.focus();
      }catch(err){
        console.warn('[sleep quiz]',err);btn.disabled=false;
        fail('Something went wrong sending your plan. Please try again in a moment.');
      }
    });
  }

  function open(from){
    if(dlg.open) return;
    opener=from||document.activeElement; a={};
    dlg.showModal(); document.documentElement.classList.add('quiz-open');
    if(location.hash!=='#quiz') history.replaceState(null,'','#quiz');
    show(0);
  }
  dlg.addEventListener('close',()=>{
    document.documentElement.classList.remove('quiz-open');
    if(location.hash==='#quiz') history.replaceState(null,'',location.pathname+location.search);
    if(opener&&opener.isConnected&&opener!==document.body) opener.focus({preventScroll:true});
  });
  dlg.querySelector('#quiz-close').addEventListener('click',()=>dlg.close());
  // keep Tab inside the dialog (showModal makes the page inert; this also stops focus escaping to the browser chrome)
  dlg.addEventListener('keydown',e=>{
    if(e.key!=='Tab') return;
    const f=[...dlg.querySelectorAll('button:not([disabled]),a[href],input:not([disabled])')].filter(el=>el.getClientRects().length&&!el.closest('[hidden]'));
    if(!f.length) return;
    const first=f[0], last=f[f.length-1];
    if(e.shiftKey&&(document.activeElement===first||document.activeElement===dlg)){e.preventDefault();last.focus()}
    else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}
  });
  document.addEventListener('click',e=>{const t=e.target.closest('#quiz-open,a[href="#quiz"]');if(!t||!dlg.isConnected)return;e.preventDefault();open(t)});
  addEventListener('hashchange',()=>{if(location.hash==='#quiz'&&dlg.isConnected)open()});
  if(location.hash==='#quiz') open();
  }

  /* ---------- boot, and re-boot a section the theme editor re-renders ---------- */
  function init(root){ initSunset(root); initPlanner(root); initClips(root); initAurora(root); initTilt(root); initEcs(root); initBuy(root); initJoin(root); initQuiz(root); }
  init(document);
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();
